import type { ComponentProps } from "react";
import BaseActionButton from "./BaseActionButton";

type DoneButtonProps = Omit<
    ComponentProps<typeof BaseActionButton>,
    "iconType" | "testId" | "buttonType" | "label" | "loadingText"
> & {
    label?: string;
    loadingText?: string;
    buttonType?: "submit" | "button";
    variant?: ComponentProps<typeof BaseActionButton>["variant"];
};

const DoneButton = ({
    label = "Done",
    loadingText = "Finishing...",
    buttonType = "button",
    variant = "secondary",
    ...props
}: DoneButtonProps) => {
    return (
        <BaseActionButton
            label={label}
            loadingText={loadingText}
            iconType="done"
            testId="done-button"
            buttonType={buttonType}
            variant={variant}
            {...props}
        />
    );
};

export default DoneButton;
